import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseForm from "@/components/BaseForm";
import BaseInput from "@/components/BaseInput";
import FormatMoney from "@/components/FormatMoney";

export default defineComponent({
  name: "CreatePayoutRequestModal",
  components: { BaseConfirm, BaseButton, BaseForm, BaseInput, FormatMoney },
  props: {
    show: { type: Boolean, required: true },
    loading: { type: Boolean, default: false },
    primaryBalance: { type: Number, required: true },
    value: { type: String, required: true },
    currencySymbol: { type: String, required: true },
    subText: { type: String, required: true },
    hasError: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const onSubmit = async () => {
      emit("submit");
    };
    const hideModal = () => {
      emit("close");
    };

    return { onSubmit, hideModal };
  },
});
